import { getFromStorage } from './../../../../used-vue/api/Storage';
import CustomerParametersObject from './customer-parameters-object';
import getFinanceTypes from './finance-types/get-finance-types';
import getFinanceRequest from './finance-request';
import openFinanceCTA from './finance-cta';
import financeEnquireNow from '../finance-enquiry-form';
import CodeweaversResponse from '../../finance/codeweavers-response';
import updateSelectFromArray from './finance-types/update-select-from-array';
import ContactFormValidator from '../../../../validation/ContactFormValidator';
import { customEvent, generateLeadEvent } from '../../../../modules/tracking/AnalyticsEvents';

export default class {
    constructor(vehicle = null, customerRef = '') {
        if (vehicle) {
            this.vehicle = vehicle;
            this.financeTypes = getFinanceTypes(this.vehicle);
            this.currentFinanceType = this.financeTypes[0];
        }
        this.customerParameters = new CustomerParametersObject();
        this.customerParameters.customerRef = customerRef;

        this.financePriceElements = document.querySelectorAll('.finance-price');

        this.cachedUnableToQuoteForm = false;
    }

    setVehicle(vehicle) {
        this.vehicle = vehicle;
        this.financeTypes = getFinanceTypes(this.vehicle);
        this.currentFinanceType = this.financeTypes[0];
    }

    sortFinanceTypes() {
        this.financeTypes.sort((a, b) => {
            if (a.order < b.order) {
                return -1;
            }
            if (a.order > b.order) {
                return 1;
            }
            return 0;
        });
    }

    buildFinanceTypeDropDown(financeTypeDropdown) {
        updateSelectFromArray(
            this.financeTypes,
            financeTypeDropdown,
            value => value.longName,
            value => value.pseudoKey,
        );
        financeTypeDropdown.selectedIndex = 0;
        return financeTypeDropdown;
    }

    changeFinanceKey(keyName) {
        keyName = keyName.toLowerCase();
        this.financeTypes.forEach(financeType => {
            if (financeType.pseudoKey.toLowerCase() == keyName) {
                this.currentFinanceType = financeType;
            }
        });
    }

    updateHeaderPrice(price = false) {
        const priceHTML = (price == false || price <= 0) ? 'N/A' : `<a href="#personalise-my-finance"><span class="price">&pound;${number_format(price,0)}</span></a>`;
        for (let index = 0, len = this.financePriceElements.length; index < len; index++) {
            this.financePriceElements[index].innerHTML = priceHTML;
        }
    }

    showUnableToQuoteForm(customerParameters, financeKeyObject, financeProduct = null) {
        $('#finance-loading').remove();
        this.updateHeaderPrice(false);
        this.hideCTAs(false);
        let message = "Please contact us directly for finance information."
        if (financeProduct) {
            message = financeProduct.getErrorMessage();
        }

        let output = `<p class="alert alert-danger"><span class="glyphicons glyphicons-exclamation-sign pull-left"></span>${message}</p><div id="no-quote-form" class="no-quote-form">`;

        this.getUnableToQuoteForm().then(html => {
            output += html + '</div>';
            $('#financeResult').html(output);
            const form = document.getElementById('unable-to-quote-form');
            const vehicle = this.vehicle;
            // console.log('LocationDataLoader', LocationDataLoader);
            window.LocationDataLoader.get()
            .then(locationData => {
                let filteredLocations = locationData.slice(0);

                if (typeof filterDealers !== 'undefined') {
                    filteredLocations = filteredLocations.filter(function (location) {
                        if (typeof filterDealers[location.id] !== 'undefined') {
                            return true;
                        }
                        return false;
                    });
                }

                const unableToQuoteFormValidator = new ContactFormValidator({
                    element: form
                });

                const locationHandler = new CustomerLocationHandler();
                // console.log('filteredLocations', filteredLocations);
                locationHandler.setLocationData(filteredLocations);
                locationHandler.setup('unable-to-quote-form');


                $(form.querySelector('textarea[name="comments"]')).on('focusout.ContactFormValidator', function () {
                    if (this.value === "") {
                        this.classList.remove('active');
                    } else {
                        this.classList.add('active');
                    }
                });

                customEvent('New Vehicle', 'Enquire about finance - no codeweavers quote', financeKeyObject.longName);

                $(form).on('submit', async function() {
                    if (!await unableToQuoteFormValidator.isValid()) {
                        return false;
                    }

                    const formData = $(this).serializeArray();
                    formData.push({
                        name:'finance-type',
                        value: financeKeyObject.longName
                    });
                    formData.push({
                        name:'customer-request',
                        value: JSON.stringify(financeKeyObject.getRelevantCustomerParameters(customerParameters))
                    });
                    formData.push({
                        name:'error-message',
                        value: message
                    });
                    formData.push({
                        name:'vehicle',
                        value: vehicle.id
                    });
                    unableToQuoteFormValidator.preventInput();

                    $.ajax({
                        longFinanceName: financeKeyObject.longName,
                        type: "POST",
                        cache: false,
                        dataType: 'json',
                        url: form.getAttribute('action'),
                        data: formData,
                        success: function(response) {
                            customEvent('New Vehicle', 'Enquire about finance - ' + this.longFinanceName, 'Complete');
                            trackPageView('/conversion/new-vehicle-enquire-about-finance/complete', 'New Vehicle - Enquire about finance Completed');

                            generateLeadEvent('new_finance_enquiry');

                            if (typeof response.name !== 'undefined') {
                                $('#financeResult').html('<h2>Thank you for your enquiry</h2><p class="nice-text">Your enquiry has been sent to ' + response.name + '.<br />Someone will be in touch soon to discuss your enquiry</p>');
                            }
                            else {
                                $('#financeResult').html('<h2>Thank you for your enquiry</h2><p class="nice-text">Your enquiry has been sent to your nearest dealer.<br />Someone will be in touch soon to discuss your enquiry</p>');
                            }

                            unableToQuoteFormValidator.allowInput();
                        },
                        error: function(response) {
                            outputErrorToForm('unable-to-quote-form', parseErrorResponse(response));
                            unableToQuoteFormValidator.allowInput();
                        }
                    });
                    return false;
                });
            });
        }, error => console.error(error));
    }

    getUnableToQuoteForm() {
        return new Promise((resolve, reject) => {
            if (this.cachedUnableToQuoteForm == false) {
                $.ajax({
                    url: "/"+brand+"/new/unable-to-quote-form",
                    type: "POST",
                    cache: false,
                    data: {},
                    dataType: "html",
                    success: response => {
                        this.cachedUnableToQuoteForm = response;
                        resolve(response);
                    },
                    error: response => {
                        reject('');
                    }
                });
            } else {
                resolve(this.cachedUnableToQuoteForm);
            }
        });
    }

    renderQuote(html) {
        if (getFromStorage('new_finance_modified', 'N') == 'Y') {
            $('.personal-quote').css('display','inline-block');
            $('#financeResult').html('<h3>Your Personal Quote^</h3><div class="finance-quote personal">'+html+'</div>');
            $('#finance-loading').remove();
            return;
        }

        $('.personal-quote').css('display','none');
        $('#financeResult').html('<h3>Representative example^</h3><div class="finance-quote">'+html+'</div>');
        $('#finance-loading').remove();
        return;
    }

    renderTermsAndConditions(html) {
        if (html == false) {
            $('#finance-terms').html('');
        }
        $('#finance-terms').html(html);
    }

    hideCTAs() {
        $('.finance-ctas').hide();
    }

    /**
     * Return a CTA inside of a <div>. Required for iPad where the buttons need padding and flexbox alone doesn't do the job
     * @param {Element} cta The button to be wrapped
     * @param {String} className The class to be added to the div. Used for CSS flex order
     */
    wrapCtaInsideDiv(cta, className) {
        const divElement = document.createElement('div');
        divElement.classList.add('finance-calculator__cta-div');
        divElement.classList.add(className);
        divElement.append(cta);
        return divElement;
    }

    renderCTAs(quote, codeweaversResponse, customerParameters, financeKeyObject) {
        const ctaArea = document.querySelector('.finance-calculator__ctas');
        if (!ctaArea) {
            console.error("Unable to find CTA area to render CTAs");
            return;
        }

        const divElement = document.createElement('div');
        divElement.classList.add('finance-calculator__ctas');

        const valueMyCarButton = document.createElement('button');
        valueMyCarButton.classList.add('btn');
        valueMyCarButton.classList.add('btn-valuation');
        valueMyCarButton.classList.add('btn-full-width-xs');
        valueMyCarButton.innerText = 'Value My Car';
        valueMyCarButton.addEventListener('click', event => {
            customEvent('New Vehicle', 'Valuation Below Finance', 'Clicked');
            startValuation();
        });
        divElement.append(this.wrapCtaInsideDiv(valueMyCarButton, 'finance-calculator__cta-div--valuation'));

        const cwFreeCreditCheckButton = document.createElement('button');
        cwFreeCreditCheckButton.classList.add('btn');
        cwFreeCreditCheckButton.classList.add('btn-finance');
        cwFreeCreditCheckButton.classList.add('btn-credit-check');
        cwFreeCreditCheckButton.classList.add('btn-full-width-xs');
        cwFreeCreditCheckButton.innerText = 'Free Credit Check';
        cwFreeCreditCheckButton.addEventListener('click', event => {
            openFinanceCTA(codeweaversResponse, 'Credit Check');
        });
        divElement.append(this.wrapCtaInsideDiv(cwFreeCreditCheckButton, 'finance-calculator__cta-div--credit'));

        const cwApplyForFinanceButton = document.createElement('button');
        cwApplyForFinanceButton.classList.add('btn');
        cwApplyForFinanceButton.classList.add('btn-finance');
        cwFreeCreditCheckButton.classList.add('btn-cw-apply');
        cwApplyForFinanceButton.classList.add('btn-full-width-xs');
        cwApplyForFinanceButton.innerText = 'Apply For Finance';
        cwApplyForFinanceButton.addEventListener('click', event => {
            openFinanceCTA(codeweaversResponse, 'Apply');
        });
        divElement.append(this.wrapCtaInsideDiv(cwApplyForFinanceButton, 'finance-calculator__cta-div--apply'));

        const enquireNowButton = document.createElement('button');
        enquireNowButton.classList.add('btn');
        enquireNowButton.classList.add('btn-primary');
        enquireNowButton.classList.add('btn-full-width-xs');
        enquireNowButton.innerText = 'Enquire Now';
        enquireNowButton.addEventListener('click', event => {
            financeEnquireNow(codeweaversResponse, customerParameters, this.vehicle);
        });
        divElement.append(this.wrapCtaInsideDiv(enquireNowButton, 'finance-calculator__cta-div--enquire'));

        ctaArea.replaceWith(divElement)
    }

    callCodeweavers() {
        return new Promise((resolve, reject) => {
            const financeRequest = getFinanceRequest(this.vehicle, this.currentFinanceType, this.customerParameters);
            const self = this;
            $.ajax({
                vehicleObject: this.vehicle,
                customerParameters: this.customerParameters,
                financeKeyObject: this.currentFinanceType,
                financeRequestPassthrough: financeRequest,
                quoteTypePassthrough: this.currentFinanceType,
                async: true,
                type: "POST",
                crossDomain: true,
                dataType: "json",
                url: "https://services.codeweavers.net/public/v2/JsonFinance/Calculate",
                data: financeRequest,
                success: function (data) {
                    resolve({
                        data: data,
                        vehicleObject: this.vehicleObject,
                        customerParameters: this.customerParameters,
                        financeKeyObject: this.financeKeyObject,
                        financeRequestPassthrough: this.financeRequestPassthrough,
                        quoteTypePassthrough: this.quoteTypePassthrough
                    });
                    return;
                },
                error: function(error) {
                    console.error('resources/assets/js/new-car-pages/modules/details/finance/new-vehicle-finance.js@callCodeweavers ', error);
                    reject({
                        error: error,
                        vehicleObject: this.vehicleObject,
                        customerParameters: this.customerParameters,
                        financeKeyObject: this.financeKeyObject,
                        financeRequestPassthrough: this.financeRequestPassthrough,
                        quoteTypePassthrough: this.quoteTypePassthrough
                    });
                    return;
                }
            });
        })
    }

    getFinance() {
        $('#financeResult').append('<div class="loading" id="finance-loading"><img src="/images/shared/Robins-And-Day-Loader.svg" alt="" /></div>');

        this.callCodeweavers()
        .then(response => {
            const data = response.data;
            const vehicleObject = response.vehicleObject;
            const customerParameters = response.customerParameters;
            const financeKeyObject = response.financeKeyObject;
            const financeRequestPassthrough = response.financeRequestPassthrough;
            const quoteTypePassthrough = response.quoteTypePassthrough;

            // console.log('test',
            //     {
            //         data: data,
            //         vehicleObject: vehicleObject,
            //         customerParameters: customerParameters,
            //         financeKeyObject: financeKeyObject,
            //         financeRequestPassthrough: financeRequestPassthrough,
            //         quoteTypePassthrough: quoteTypePassthrough
            //     }
            // )
            const codeweaversResponse = new CodeweaversResponse(data, financeRequestPassthrough, vehicleObject, financeKeyObject);
            const product = codeweaversResponse.getFinanceProductOfInterest(financeKeyObject);
            if (product.hasError()) {
                this.showUnableToQuoteForm(customerParameters, financeKeyObject, product);
                return;
            }
            const html = this.currentFinanceType.render(codeweaversResponse);
            this.renderQuote(html);
            this.updateHeaderPrice(this.currentFinanceType.getPrice(codeweaversResponse));

            const termsAndConditions = this.currentFinanceType.getTermsAndConditions(codeweaversResponse);
            this.renderTermsAndConditions(termsAndConditions);

            let quote = codeweaversResponse.getFinanceProductOfInterest(financeKeyObject);
            this.renderCTAs(quote, codeweaversResponse, customerParameters, financeKeyObject);
        })
        .catch(response => {
            const error = response.error;
            // console.log('error', error);
            const vehicleObject = response.vehicleObject;
            const customerParameters = response.customerParameters;
            const financeKeyObject = response.financeKeyObject;
            const financeRequestPassthrough = response.financeRequestPassthrough;
            const quoteTypePassthrough = response.quoteTypePassthrough;

            this.showUnableToQuoteForm(customerParameters, financeKeyObject, product);
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/new-vehicle-finance.js